import { Button } from '@malesia/react-components/dist/src/components/Button';
import { PageTitle } from '@malesia/react-components/dist/src/components/Page/Title';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { allAdminRoutePaths } from '../../../containers/Routes/allAdminRoutePaths';
import { flightCompanyListPermissions } from '../../../permissions/adminPages/flight/flightCompanyList';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

export const FlightCompanyListHeaderWithStore: SFC = () => {
    const userPermissions = useUserPermissions();

    return (
        <PageTitle
            text={
                <FormattedMessage
                    id='front-app/FlightCompanyListPage:Title'
                    defaultMessage='Airline Company'
                />
            }
            rightSlot={
                <Link to={allAdminRoutePaths.flightCompanyNew}>
                    <Button
                        icon='plus'
                        text={
                            <FormattedMessage
                                id='front-app/FlightCompany/List:AddFlightCompany'
                                defaultMessage='Add airline company'
                            />
                        }
                    />
                </Link>
            }
            rightSlotHidden={!userPermissions.has(flightCompanyListPermissions.newLink)}
        />
    );
};
